import { tr } from "../../i18n";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout, { Field, ErrorNote, inputCls } from "./AuthLayout";
import { useAuth, api, apiError } from "../../auth/AuthContext";
export default function Register() {
  const {
    lang = "en"
  } = useParams();
  const navigate = useNavigate();
  const {
    setUser
  } = useAuth();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    company: "",
    job_title: "",
    email: "",
    password: "",
    confirm_password: "",
    country: "",
    phone: "",
    agree: false
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(f => ({
    ...f,
    [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value
  }));
  const submit = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/auth/register", form);
      setUser(r.data);
      toast.success(tr("Your ESAIA account has been created."));
      navigate(`/${lang}/portal`);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };
  return <AuthLayout title={tr("Create your ESAIA Account")} subtitle={tr("Access your assessments, reports and certificates in the Client Portal.")}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <ErrorNote error={error} />
        <div className="grid grid-cols-2 gap-4">
          <Field label={tr("First name")} required htmlFor="reg-first">
            <input id="reg-first" required value={form.first_name} onChange={set("first_name")} className={inputCls} data-testid="register-first-name" />
          </Field>
          <Field label={tr("Last name")} required htmlFor="reg-last">
            <input id="reg-last" required value={form.last_name} onChange={set("last_name")} className={inputCls} data-testid="register-last-name" />
          </Field>
        </div>
        <Field label={tr("Company")} required htmlFor="reg-company">
          <input id="reg-company" required value={form.company} onChange={set("company")} className={inputCls} data-testid="register-company" />
        </Field>
        <Field label={tr("Job title")} htmlFor="reg-title">
          <input id="reg-title" value={form.job_title} onChange={set("job_title")} className={inputCls} data-testid="register-job-title" />
        </Field>
        <Field label={tr("Email")} required htmlFor="reg-email">
          <input id="reg-email" type="email" required value={form.email} onChange={set("email")} className={inputCls} data-testid="register-email" autoComplete="email" />
        </Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label={tr("Country")} htmlFor="reg-country">
            <input id="reg-country" value={form.country} onChange={set("country")} className={inputCls} data-testid="register-country" />
          </Field>
          <Field label={tr("Phone number")} htmlFor="reg-phone">
            <input id="reg-phone" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="register-phone" />
          </Field>
        </div>
        <Field label={tr("Password")} required htmlFor="reg-pass">
          <input id="reg-pass" type="password" required value={form.password} onChange={set("password")} className={inputCls} data-testid="register-password" autoComplete="new-password" />
          <p className="mt-1 text-[11px] text-esaia-subtle">{tr("Minimum 8 characters, with a letter and a number.")}</p>
        </Field>
        <Field label={tr("Confirm password")} required htmlFor="reg-pass2">
          <input id="reg-pass2" type="password" required value={form.confirm_password} onChange={set("confirm_password")} className={inputCls} data-testid="register-confirm-password" autoComplete="new-password" />
        </Field>
        <label className="flex items-start gap-3 text-sm text-esaia-muted" data-testid="register-agree-label">
          <input type="checkbox" checked={form.agree} onChange={set("agree")} className="mt-0.5 h-4 w-4 accent-esaia-blue" data-testid="register-agree" />
          <span>{tr("I agree to the")}{" "}
            <Link to={`/${lang}/legal/terms`} className="font-semibold text-esaia-blue hover:underline">{tr("ESAIA Terms")}</Link>{" "}{tr("and")}{" "}
            <Link to={`/${lang}/legal/privacy`} className="font-semibold text-esaia-blue hover:underline">{tr("Privacy Policy")}</Link>.
          </span>
        </label>
        <button type="submit" disabled={loading} data-testid="register-form-submit-button" className="w-full bg-esaia-blue px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark disabled:opacity-60">
          {loading ? tr("Creating account...") : tr("Create Account")}
        </button>
        <p className="pt-1 text-center text-xs text-esaia-subtle">{tr("Already have an account?")}{" "}
          <Link to={`/${lang}/login`} className="font-semibold text-esaia-blue hover:underline">{tr("Log in")}</Link>
        </p>
      </form>
    </AuthLayout>;
}
